const getters = {
  showLandingMenu: state => state.showLandingMenu,
  isPaymentHistoryOpen: state => state.isPaymentHistoryOpen,
}

export default getters
